// layout布局页
import main from "@pages/main";
// 登录
import login from "@pages/login";
// 首页
import index from "@pages/index";
import index1 from "@pages/index1";
// 文件to内网
import upload from "@pages/upload";
// 个人中心
import user from "@pages/user";
//提案
import proposal from "../pages/proposal/proposal";
//提案库
import proposalLibrary from "../pages/proposal/proposalLibrary";
// 通用线索(渠道、自采)
import clue from "@pages/clue/clue";
// 自采线索
import produceClues from "@pages/clue/produceClues";
// 互联网线索
import internetClues from "@pages/clue/internetClues";
// 渠道线索
import channelClues from "@pages/clue/channelClues";
// 收录线索
import includedClues from "@pages/clue/includedClues";
// 我的线索
import myClues from "@pages/clue/myClues";
// 线索详情
import clueDetail from "@pages/clue/clueDetail";
// 线索详情
import clueDetailRadio from "@pages/clue/clueDetailRadio";
//报道库
import reports from "@pages/report/reports";
// 报道审核
import checkReports from "@pages/report/checkReports";
// 我的报道
import myReports from "@pages/report/myReports";
// 报道详情
import reportDetail from "@pages/report/reportDetail";
// 报道详情
import reportDetailRadio from "@pages/report/reportDetailRadio";
//视频语音转文字
import mediaToText from "@pages/mediaToText";
//创建线索
import creatClue from "@pages/clue/editClue";
// 编辑线索
import editClue from "@pages/clue/editClue";
//新建报片
import creatReport from "@pages/report/editReport";
// 编辑报道
import editReport from "@pages/report/editReport";
//小康工程
import xkgcs from "@pages/xkgc/xkgcs";
// 小康工程审核
import checkXkgc from "@pages/xkgc/checkXkgc";
// 我的小康工程
import myXkgc from "@pages/xkgc/myXkgc";
// 小康工程详情
import xkgcDetail from "@pages/xkgc/xkgcDetail";
//新建小康工程
import creatXkgc from "@pages/xkgc/editXkgc";
// 编辑小康工程
import editXkgc from "@pages/xkgc/editXkgc";
//公共串联单库
import publics from "@pages/public/publics";
// 公共串联单详情
import publicDetail from "@pages/public/publicDetail";
// 采访库
import allInterviews from "@pages/interview/allInterviews";
// 延期审核
import delayCheck from "@pages/interview/delayCheck";
// 我的采访
import myInterviews from "@pages/interview/myInterviews";
// 采访审核
import checkInterviews from "@pages/interview/checkInterviews";
// 采访详情
import interviewDetail from "@pages/interview/interviewDetail";
// 新建采访
import newInterview from "@pages/interview/newInterview";
// 编辑采访
import editInterview from "@pages/interview/editInterview";
// 资源分配
import resources from "@pages/resource/resources";
// 设备管理
import equipments from "@pages/resource/equipments";

import tuozhanfenpei from "@pages/resource/tuozhanfenpei";

import tuozhanshebei from "@pages/resource/tuozhanshebei";
// 人员管理
import people from "@pages/resource/people";
// 设备详情
import equipmentDetail from "@pages/resource/equipmentDetail";
// 拓展设备详情
import extraEquipmentDetail from "@pages/resource/extraEquipmentDetail";
// 人员详情
import peopleDetail from "@pages/resource/peopleDetail";
// GPS汇报
import GPS from "@pages/resource/GPS";
// 选题库
import topics from "@pages/topic/topics";
// 我的选题
import myTopics from "@pages/topic/myTopics";
// 新建选题
import newTopic from "@pages/topic/newTopic";
// 选题详情
import topicDetail from "@pages/topic/topicDetail";
// 帮助中心
import help from "@pages/help";
// 公告详情
import announcement from "@pages/announcement";
// 版本信息
import version from "@pages/version";
// 看看发布
import kankan from "@pages/data/kankan";
// 电视报片
import tv from "@pages/data/tv";
// 栏目考评
import sectionEvaluation from "@pages/evaluation/sectionEvaluation";
// 部门考评
import departEvaluation from "@pages/evaluation/departEvaluation";
// 个人统计
import personStatic from "@pages/evaluation/personStatic";
// 部门统计
import departStatic from "@pages/evaluation/departStatic";
// 栏目考评打印
import print from "@pages/print";
// 串联单详情页
import tandem from "@pages/tandem";
// 素材模版
import material from "@pages/file/material";
// 发布库
import publishLibrary from "@pages/publish/publishLibrary";
// 审核发布
import publishAudit from "@pages/publish/publishAudit";
//我的发布
import myPublish from "@pages/publish/myPublish";
// 新建/编辑发布
import editPublish from "@pages/publish/editPublish";
// 发布详情
import publishDetail from "@pages/publish/publishDetail";
// 发布详情
import publishDetailRadio from "@pages/publish/publishDetailRadio";
// 音频剪辑
import voiceEdit from "@components/voiceEdit/voiceEditRadio";
// 我的素材
import myMaterial from "@pages/material/myMaterial";

import downloadTest from "@components/download";

import cloudEdit from "@pages/cloudEdit";

import backendLogin from "@pages/backendLogin";

import anchor from "@pages/anchor/anchor";

import streamMedia from "@pages/streamMedia/streamMedia";

import share from "@pages/share/share";

import newmediashare from "@pages/newmediashare/newmediashare";

import editMediaPublish from "@pages/mediaPublish/editMediaPublish";

import mediaPublishDetail from "@pages/mediaPublish/mediaPublishDetail";

import myMediaPublish from "@pages/mediaPublish/myMediaPublish";

import mediaPublishLibrary from "@pages/mediaPublish/mediaPublishLibrary";

import mediaPublishAudit from "@pages/mediaPublish/mediaPublishAudit";

import filter from "@pages/filter/index";

import mediaDetail from "@pages/mediaDetail";

import client from "@pages/analysis/client";

import media from "@pages/analysis/media";

import mtkb from "@pages/analysis/mediaDetail";

import analysisList from "@pages/analysis/analysisList";

import analysisDetail from "@pages/analysis/analysisDetail";

import contentTrack from "@pages/analysis/contentTrack";

import contentTrackList from "@pages/analysis/contentTrackList";

import contentTrackDetail from "@pages/analysis/contentTrackDetail";

import timeVideo from "@pages/timeVideo";

import themeTrack from "@pages/themeTrack";

import dataCenter from "@pages/dataCenter";

import sportDataCenter from "@pages/sportDataCenter";

import voiceRec from "@pages/voiceRec";

import voiceEditList from "@pages/voiceEditList";

import empower from "@pages/empower";
import backendAudit from "@pages/backendAudit";

import dyPreviewBox from "@pages/dyPreviewBox/dyPreviewBox";

import backendFilter from "@pages/backendFilter";

import voiceComposeList from "@pages/voiceComposeList"

import voiceCompose from "@pages/voiceCompose"
import voiceComposeCustom from "@/pages/voiceComposeCustom.vue";

import dailyReport from "@pages/dailyReport/dailyReport";

import newTopicList from "@pages/newTopic/allTopic";

import newTopicEdit from "@pages/newTopic/newTopic";

import newTopicDetail from "@pages/newTopic/topicDetail";

import newMyTopic from "@pages/newTopic/myTopic";

import newTopicAudit from "@pages/newTopic/checkTopics";
import unifiedContentLibrary from '@pages/unifiedContentLibrary/index.vue'
import previewLibrary from '@pages/unifiedContentLibrary/preview.vue'

import onlinePlayingLibrary from '@pages/onlinePlayingList/index.vue'

let domin = window.document.domain;
let isXnew = true;
if (domin.indexOf("xnews") != -1) {
  isXnew = true;
} else if (domin.indexOf("localhost") != -1) {
  isXnew = true;
} else {
  isXnew = false;
}

export default {
  pages: [
    {
      path: "/",
      component: main,
      redirect: "/index",
      children: [
        {
          name: "user",
          path: "user/:type?",
          component: user,
          title: "个人设置"
        },
        {
          path: "index",
          component: index,
          title: "X NEWS", // 页面标题，可用于header部分和浏览器title
          showLink: true // 是否显示超链接，目前只有首页需要；与title不共存
        },
        {
          path: "announcement",
          component: announcement,
          title: "最新公告",
          showLink: false
        },
        {
          path: "allInterviews/:id",
          component: allInterviews,
          title: "采访库",
          showLink: false
        },
        {
          name: "myInterviews",
          path: "myInterviews/:id",
          component: myInterviews,
          title: "我的采访",
          showLink: false
        },
        {
          name: "delayCheck",
          path: "delayCheck/:id",
          component: delayCheck,
          title: "延期审核",
          showLink: false
        },
        {
          name: "checkInterviews",
          path: "checkInterviews/:id",
          component: checkInterviews,
          title: "采访审核",
          showLink: false
        },
        {
          path: "interviewDetail",
          component: interviewDetail,
          title: "",
          showLink: false
        },
        {
          path: "interviewCheck",
          component: interviewDetail,
          title: "采访审核",
          showLink: false
        },
        {
          name: "newInterview",
          path: "newInterview",
          component: newInterview,
          title: "新建采访",
          showLink: false
        },
        {
          path: "editInterview",
          component: editInterview,
          title: "编辑采访",
          showLink: false
        },
        {
          name: "resources",
          path: "resources/:id",
          component: resources,
          title: "资源分配",
          showLink: false
        },
        {
          name: "tuozhanfenpei",
          path: "tuozhanfenpei/:id",
          component: tuozhanfenpei,
          title: "拓展分配",
          showLink: false
        },
        {
          name: "tuozhanshebei",
          path: "tuozhanshebei/:id",
          component: tuozhanshebei,
          title: "拓展设备",
          showLink: true
        },
        {
          path: "equipments/:id",
          component: equipments,
          title: "设备管理",
          showLink: false
        },
        {
          path: "people/:id",
          component: people,
          title: "人员管理",
          showLink: false
        },
        {
          path: "equipmentDetail",
          component: equipmentDetail,
          title: "",
          showLink: false
        },
        {
          path: "extraEquipmentDetail",
          component: extraEquipmentDetail,
          title: "",
          showLink: false
        },
        {
          path: "peopleDetail",
          component: peopleDetail,
          title: "",
          showLink: false
        },
        {
          path: "GPS/:id",
          component: GPS,
          title: "GPS汇报",
          showLink: false
        },
        {
          name: "topics",
          path: "topics/:id",
          component: topics,
          title: "策划库",
          showLink: false
        },
        {
          name: "myTopics",
          path: "myTopics/:id",
          component: myTopics,
          title: "我的策划",
          showLink: false
        },
        {
          path: "newTopic",
          component: newTopic,
          title: "新建策划",
          showLink: false
        },
        {
          path: "topicDetail",
          component: topicDetail,
          title: "",
          showLink: false
        },
        //提案
        {
          title: "我的提案",
          showLink: false,
          path: "proposal/:id",
          component: proposal
        },
        //提案库
        {
          title: "提案库",
          showLink: false,
          path: "proposalLibrary/:id",
          component: proposalLibrary
        },
        // 通用线索
        {
          name: "clue",
          title: "",
          showLink: false,
          path: "clue/:id",
          component: clue
        },
        //互联网线索
        {
          name: "internetClue",
          title: "互联网线索",
          showLink: false,
          path: "internetClue/:id",
          component: internetClues
        },
        //渠道线索
        {
          name: "channelClue",
          title: "渠道线索",
          showLink: false,
          path: "channelClue/:id",
          component: channelClues
        },
        //自采线索
        {
          name: "selfClue",
          title: "自采线索",
          showLink: false,
          path: "selfClue/:id",
          component: produceClues
        },
        //收录线索
        {
          name: "includedClue",
          title: "收录线索",
          showLink: false,
          path: "includedClue/:id",
          component: includedClues
        },
        //我的线索
        {
          name: "myClue",
          title: "我的线索",
          showLink: false,
          path: "myClue/:id",
          component: myClues
        },
        //报道库
        {
          name: "reports",
          title: "报道库",
          showLink: false,
          path: "reportLibrary/:id",
          component: reports
        },
        //我的报道
        {
          name: "myreport",
          title: "我的报道",
          showLink: false,
          path: "myreport/:id",
          component: myReports
        },
        //审核报道
        {
          name: "examineReport",
          title: "报道审核",
          showLink: false,
          path: "examineReport/:id",
          component: checkReports
        },
        //小康工程稿库
        {
          name: "xkgcs",
          title: "小康工程稿库",
          showLink: false,
          path: "xkgcLibrary/:id",
          component: xkgcs
        },
        //我的小康工程稿
        {
          name: "myxkgc",
          title: "我的小康工程稿",
          showLink: false,
          path: "myxkgc/:id",
          component: myXkgc
        },
        //审核小康工程稿
        {
          name: "examineXkgc",
          title: "小康工程稿审核",
          showLink: false,
          path: "examineXkgc/:id",
          component: checkXkgc
        },
        //公共串联单稿库
        {
          name: "publics",
          title: "公共串联单稿库",
          showLink: false,
          path: "publicLibrary/:id",
          component: publics
        },
        // 看看发布
        {
          title: "看看发布",
          showLink: false,
          path: "kankan/:id",
          component: kankan
        },
        // 电视报片
        {
          title: "电视报片",
          showLink: false,
          path: "tv/:id",
          component: tv
        },
        {
          title: "栏目考评",
          showLink: false,
          path: "sectionEvaluation/:id",
          component: sectionEvaluation
        },
        {
          title: "部门考评",
          showLink: false,
          path: "departEvaluation/:id",
          component: departEvaluation
        },
        {
          title: "个人统计",
          showLink: false,
          path: "personStatic/:id",
          component: personStatic
        },
        {
          title: "部门统计",
          showLink: false,
          path: "departStatic/:id",
          component: departStatic
        },
        {
          title: "素材",
          showLink: false,
          path: "file/:id",
          component: material
        },
        {
          name: "publishLibrary",
          title: "发布库",
          showLink: false,
          path: "publishLibrary/:id",
          component: publishLibrary
        },
        {
          name: "publishAudit",
          title: "发布审核",
          showLink: false,
          filter: false,
          path: "publishAudit/:id",
          component: publishAudit
        },
        {
          name: "myPublish",
          title: "我的发布",
          showLink: false,
          filter: false,
          path: "myPublish/:id",
          component: myPublish
        },
        {
          name: "myMaterial",
          title: "我的素材",
          showLink: false,
          filter: false,
          path: "myMaterial/:id",
          component: myMaterial
        },
        {
          name: "myMediaPublish",
          title: "我的新媒体发布",
          showLink: false,
          filter: false,
          path: "myMediaPublish/:id",
          component: myMediaPublish
        },
        {
          name: "mediaPublishLibrary",
          title: "新媒体发布库",
          showLink: false,
          filter: false,
          path: "mediaPublishLibrary/:id",
          component: mediaPublishLibrary
        },
        {
          name: "mediaPublishAudit",
          title: "新媒体发布审核",
          showLink: false,
          filter: false,
          path: "mediaPublishAudit/:id",
          component: mediaPublishAudit
        },
        {
          path: "/dataCenter",
          name: "dataCenter",
          component: dataCenter,
          title: "数据中心",
          showLink: false,
          filter: false
        },
        {
          path: "/sportDataCenter",
          name: "sportDataCenter",
          component: sportDataCenter,
          title: "数据中心",
          showLink: false,
          filter: false
        },
        {
          path: "/voiceRec",
          name: "voiceRec",
          component: voiceRec,
          title: "语音识别",
          showLink: false,
          filter: false
        },
        {
          path: "/voiceEditList",
          name: "voiceEditList",
          component: voiceEditList,
          title: "音频剪辑",
          showLink: false,
          filter: false
        },
        {
          path: "/voiceComposeList",
          name: "voiceComposeList",
          component: voiceComposeList,
          title: "语音合成",
          showLink: false,
          filter: false
        },
        {
          path: "/newTopicList/:id",
          name: "newTopicList",
          component: newTopicList,
          title: "选题库",
          showLink: false,
          filter: false
        },
        {
          path: "/newTopicEdit",
          name: "newTopicEdit",
          component: newTopicEdit,
          title: "选题库",
          showLink: false,
          filter: false
        },
        {
          path: "/newTopicDetail",
          name: "newTopicDetail",
          component: newTopicDetail,
          title: "选题详情",
          showLink: false,
          filter: false
        },
        {
          path: "/newMyTopic/:id",
          name: "newMyTopic",
          component: newMyTopic,
          title: "我的选题",
          showLink: false,
          filter: false
        },
        {
          path: "/newTopicAudit/:id",
          name: "newTopicAudit",
          component: newTopicAudit,
          title: "选题审核",
          showLink: false,
          filter: false
        },
        {
          // history模式需要通配所有路由，详见vue-router文档
          // 统一内容库路由
          path: '/unifiedContentLibrary/:pathMatch(.*)*',
          name: 'unifiedContentLibrary',
          meta: {},
          component: unifiedContentLibrary
        },
        {
          // history模式需要通配所有路由，详见vue-router文档
          // 统一内容库路由
          path: '/onlinePlayingLibrary/:pathMatch(.*)*',
          name: 'onlinePlayingLibrary',
          meta: {},
          component: onlinePlayingLibrary
        }
      ]
    },
    {
      path: "/publishDetail",
      title: "发布详情",
      showLink: false,
      component: publishDetail
    },
    {
      path: "/publishDetailRadio",
      title: "发布详情",
      showLink: false,
      component: publishDetailRadio
    },
    {
      name: "createPublish",
      title: "新建发布",
      showLink: false,
      path: "/createPublish",
      component: editPublish
    },
    {
      name: "editPublish",
      title: "编辑发布",
      showLink: false,
      path: "/editPublish",
      component: editPublish
    },
    {
      path: "/clueDetail",
      component: clueDetail,
      title: "线索详情",
      showLink: false
    },
    {
      path: "/clueDetailRadio",
      component: clueDetailRadio,
      title: "线索详情",
      showLink: false
    },
    {
      path: "/reportDetail",
      title: "报道详情",
      showLink: false,
      component: reportDetail
    },
    {
      path: "/reportDetailRadio",
      title: "报道详情",
      showLink: false,
      component: reportDetailRadio
    },
    {
      path: "/reportCheck",
      title: "报道审核",
      showLink: false,
      component: reportDetail
    },
    {
      path: "/reportCheckRadio",
      title: "报道审核",
      showLink: false,
      component: reportDetailRadio
    },
    {
      path: "/xkgcDetail",
      title: "小康工程稿详情",
      showLink: false,
      component: xkgcDetail
    },
    {
      path: "/xkgcCheck",
      title: "小康工程稿审核",
      showLink: false,
      component: xkgcDetail
    },
    {
      path: "/publicDetail",
      title: "公共串联单稿详情",
      showLink: false,
      component: publicDetail
    },
    //创建线索
    {
      name: "creatClue",
      title: "创建线索",
      showLink: false,
      path: "/creatClue",
      component: creatClue
    },
    //新建报片
    {
      name: "creatReport",
      title: "新建报片",
      showLink: false,
      path: "/creatReport",
      component: creatReport
    },
    //新建小康工程
    {
      name: "creatXkgc",
      title: "新建小康工程稿",
      showLink: false,
      path: "/creatXkgc",
      component: creatXkgc
    },
    //编辑线索
    {
      title: "编辑线索",
      showLink: false,
      path: "/editClue",
      component: editClue
    },
    //编辑报道
    {
      title: "编辑报道",
      showLink: false,
      path: "/editReport",
      component: editReport
    },
    //编辑小康工程
    {
      title: "编辑小康工程稿",
      showLink: false,
      path: "/editXkgc",
      component: editXkgc
    },
    //视频语音转文字
    {
      title: "视频语音转文字",
      showLink: false,
      path: "/videotoword",
      component: mediaToText
    },
    //音频语音转文字
    {
      title: "音频语音转文字",
      showLink: false,
      path: "/audiotoword",
      component: mediaToText
    },
    {
      path: "/login/:type?",
      component: login,
      title: "登录",
      showLink: false
    },
    {
      path: "/adlogin",
      component: backendLogin,
      title: "后台登录",
      showLink: false
    },
    {
      path: "/upload",
      component: upload,
      title: "文件to内网",
      showLink: false
    },
    {
      path: "/help",
      component: help,
      title: "帮助中心",
      showLink: false
    },
    {
      path: "/version",
      component: version,
      title: "版本信息",
      showLink: false
    },
    {
      path: "/print",
      component: print,
      title: "打印打分",
      showLink: false
    },
    {
      path: "/cloudEdit/:type?",
      component: cloudEdit,
      title: "在线云剪辑",
      showLink: false
    },
    {
      path: "/tandem",
      component: tandem,
      title: "报道详情",
      showLink: false
    },
    {
      path: "/voiceEdit/:type?/:id?/:idString?",
      component: voiceEdit,
      title: "音频剪辑",
      showLink: false
    },
    {
      path: "/downloadTest/:url?/:params?",
      name: "downloadTest",
      component: downloadTest,
      title: "测试下载",
      showLink: false
    },
    {
      path: "/anchor",
      name: "anchor",
      component: anchor,
      title: "虚拟主播",
      showLink: false
    },
    {
      path: "/streamMedia",
      name: "streamMedia",
      component: streamMedia,
      title: "流媒体媒资",
      showLink: false
    },
    {
      path: "/share/:idstring?",
      name: "share",
      component: share,
      title: "流媒体媒资",
      showLink: false
    },
    {
      path: "/newmediashare/:idstring?/:type?",
      name: "newmediashare",
      component: newmediashare,
      title: "流媒体媒资",
      showLink: false
    },
    {
      path: "/editMediaPublish/:id?",
      name: "editMediaPublish",
      component: editMediaPublish,
      title: "新媒体发布",
      showLink: false
    },
    {
      path: "/createMediaPublish/:id?",
      name: "editMediaPublish",
      component: editMediaPublish,
      title: "新媒体发布",
      showLink: false
    },
    {
      path: "/mediaPublishDetail",
      name: "mediaPublishDetail",
      component: mediaPublishDetail,
      title: "新媒体发布详情",
      showLink: false
    },
    {
      path: "/filter",
      name: "filter",
      component: filter,
      title: "",
      showLink: false
    },
    {
      path: "/mediaDetail",
      name: "mediaDetail",
      component: mediaDetail,
      title: "",
      showLink: false
    },
    {
      path: "/client",
      name: "client",
      component: client,
      title: "",
      showLink: false
    },
    {
      path: "/media",
      name: "media",
      component: media,
      title: "",
      showLink: false
    },
    {
      path: "/mtkbDetail",
      name: "mtkbDetail",
      component: mtkb,
      title: "",
      showLink: false
    },
    {
      path: "/analysisList",
      name: "analysisList",
      component: analysisList,
      title: "",
      showLink: false
    },
    {
      path: "/analysisDetail",
      name: "analysisDetail",
      component: analysisDetail,
      title: "",
      showLink: false
    },
    {
      path: "/contentTrack",
      name: "contentTrack",
      component: contentTrack,
      title: "",
      showLink: false
    },
    {
      path: "/contentTrackList",
      name: "contentTrackList",
      component: contentTrackList,
      title: "",
      showLink: false
    },
    {
      path: "/contentTrackDetail",
      name: "contentTrackDetail",
      component: contentTrackDetail,
      title: "",
      showLink: false
    },
    {
      path: "/timeVideo",
      name: "timeVideo",
      component: timeVideo,
      title: "时移回看",
      showLink: false
    },
    {
      path: "/themeTrack",
      name: "themeTrack",
      component: themeTrack,
      title: "专题追踪",
      showLink: false
    },
    {
      path: "/empower",
      name: "empower",
      component: empower,
      title: "移动端鉴权",
      showLink: false
    },
    {
      path: "/backendAudit",
      name: "backendAudit",
      component: backendAudit,
      title: "后台流程审核",
      showLink: false
    },
    {
      path: "/dyPreviewBox",
      name: "dyPreviewBox",
      component: dyPreviewBox,
      title: "抖音预览",
      showLink: false
    },
    {
      path: "/backendFilter",
      name: "backendFilter",
      component: backendFilter,
      title: "后台筛选",
      showLink: false
    },
    {
      path: "/voiceCompose",
      name: "voiceCompose",
      component: voiceCompose,
      title: "语音合成",
      showLink: false
    },
    {
      path: "/voiceComposeCustom",
      name: "voiceComposeCustom",
      component: voiceComposeCustom,
      title: "语音合成",
      showLink: false
    },
    {
      path: "/dailyReport",
      name: "dailyReport",
      component: dailyReport,
      title: "数据日报",
      showLink: false
    },
    // 统一内容库预览
    {
      path: "/previewLibrary/:pathMatch(.*)*",
      title: "",
      showLink: false,
      component: previewLibrary
    },
    {
      path: "*",
      redirect: "/index",
      title: "X NEWS",
      showLink: false
    }
  ]
};
